// extracted by mini-css-extract-plugin
module.exports = {"title":"Popular_title__3xQ_a","btnOpen":"Popular_btnOpen__WAG0b","name":"Popular_name__XYQgT","item":"Popular_item__XTcNR","wrap":"Popular_wrap__bWHAF"};